import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql/graphqlTypes'
import { useProductsLocaleText } from '../../locale'

export const getVariantSelectorTitle = (
  categoryDepartment: string,
  localiseText: ReturnType<typeof useProductsLocaleText>,
) => {
  return localiseText(
    categoryDepartment === DepartmentsEnum.FLOWERS
      ? 'common.select_bouquet_size'
      : 'common.select_size',
  )
}
